import React from 'react'
import styled from 'styled-components'

import { Icon, H1, Header, Screen, Section } from 'ui'

const Container = styled(Section.Lighter) `
  height: 100vh;
  padding-bottom: 22px;

  @media screen and (max-width: 640px) {
    padding-bottom: 92px;
  }
`

const Content = styled(Screen) `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

const Title = styled(H1) `
  margin: 50px 0px 0px 0px;
`

const CallToAction = styled.a `
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;

  &:hover {
    font-weight: bold;
  }

  svg {
    margin-top: 10px;
    font-size: 18px;
  }
`

const Hero = ({ children }) => (
  <Container>
    <Content>
      <Header />
      <Title>
        Creative, Marketing and Communication consultancy
        for high potential companies
      </Title>
      <CallToAction>
        View portfolio
        <Icon.ChevronCircleDown />
      </CallToAction>
    </Content>
  </Container>
)

export default Hero
